


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Job, Skill } from '@/types'
import Level from "./Level.vue"

@Component({components: {
  Level
}})
export default class Skills extends Vue {
  @Prop() skills!: Array<Skill>;

}
